import { Box } from '@terra/ui-styled-system';
import type { PortalRegion } from '../../utils/portalRegions';
import { PORTAL_REGION } from '../../utils/portalRegions';

export const PORTAL_REGION_CARD_WIDTH = 100;
export const PORTAL_REGION_CARD_HEIGHT = 30;

type PortalRegionFlagIconProps = {
  region: PortalRegion;
  alt: string;
};

function UsaFlagIcon({ alt }: { alt: string }) {
  return (
    <svg
      style={{
        width: '100%',
        height: '100%',
      }}
      viewBox="0 0 60 36"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label={alt}
    >
      <title>{alt}</title>
      <rect width="60" height="36" fill="#B22234" />
      <rect y="2.77" width="60" height="2.77" fill="#fff" />
      <rect y="8.31" width="60" height="2.77" fill="#fff" />
      <rect y="13.85" width="60" height="2.77" fill="#fff" />
      <rect y="19.38" width="60" height="2.77" fill="#fff" />
      <rect y="24.92" width="60" height="2.77" fill="#fff" />
      <rect y="30.46" width="60" height="2.77" fill="#fff" />
      <rect width="24" height="19.38" fill="#3C3B6E" />
      <circle cx="4" cy="3.5" r="1.1" fill="#fff" />
      <circle cx="8" cy="3.5" r="1.1" fill="#fff" />
      <circle cx="12" cy="3.5" r="1.1" fill="#fff" />
      <circle cx="16" cy="3.5" r="1.1" fill="#fff" />
      <circle cx="20" cy="3.5" r="1.1" fill="#fff" />
      <circle cx="6" cy="7.5" r="1.1" fill="#fff" />
      <circle cx="10" cy="7.5" r="1.1" fill="#fff" />
      <circle cx="14" cy="7.5" r="1.1" fill="#fff" />
      <circle cx="18" cy="7.5" r="1.1" fill="#fff" />
      <circle cx="4" cy="11.5" r="1.1" fill="#fff" />
      <circle cx="8" cy="11.5" r="1.1" fill="#fff" />
      <circle cx="12" cy="11.5" r="1.1" fill="#fff" />
      <circle cx="16" cy="11.5" r="1.1" fill="#fff" />
      <circle cx="20" cy="11.5" r="1.1" fill="#fff" />
      <circle cx="6" cy="15.5" r="1.1" fill="#fff" />
      <circle cx="10" cy="15.5" r="1.1" fill="#fff" />
      <circle cx="14" cy="15.5" r="1.1" fill="#fff" />
      <circle cx="18" cy="15.5" r="1.1" fill="#fff" />
    </svg>
  );
}

function EuropeFlagIcon({ alt }: { alt: string }) {
  const starPoints =
    'M12,1.5 L13.1,4.6 L16.3,4.6 L13.6,6.5 L14.7,9.6 L12,7.7 L9.3,9.6 L10.4,6.5 L7.7,4.6 L10.9,4.6 Z';

  return (
    <svg
      style={{
        width: '100%',
        height: '100%',
      }}
      viewBox="0 0 60 40"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label={alt}
    >
      <title>{alt}</title>
      <rect width="60" height="40" fill="#003399" />
      <g fill="#FFCC00" transform="translate(30,20)">
        <path d={starPoints} transform="translate(0,-14) scale(0.55)" />
        <path
          d={starPoints}
          transform="rotate(30) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(60) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(90) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(120) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(150) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(180) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(210) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(240) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(270) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(300) translate(0,-14) scale(0.55)"
        />
        <path
          d={starPoints}
          transform="rotate(330) translate(0,-14) scale(0.55)"
        />
      </g>
    </svg>
  );
}

export function PortalRegionFlagIcon({
  region,
  alt,
}: PortalRegionFlagIconProps) {
  const flag =
    region === PORTAL_REGION.USA ? (
      <UsaFlagIcon alt={alt} />
    ) : region === PORTAL_REGION.EUROPE ? (
      <EuropeFlagIcon alt={alt} />
    ) : null;

  return (
    <Box
      w={`${PORTAL_REGION_CARD_WIDTH}px`}
      h={`${PORTAL_REGION_CARD_HEIGHT}px`}
      flexShrink={0}
      borderRadius="sm"
      overflow="hidden"
      lineHeight={0}
    >
      {flag}
    </Box>
  );
}
